import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { startAddEntityFromMenu } from '../../actions/campaignAndGroupSelector';
import { AddEntityMenu, AddEntityMenuProps } from '../../components/AddEntityMenu/AddEntityMenu';
import { BANNERS_IN_GROUP_LIMIT, INTERNAL_BANNERS_IN_GROUP_LIMIT } from '../../constants';
import { selectAddEntityItems } from '../../selectors/sidebar/sidebar';
import { AddEntityItem } from '../../typings/sidebar';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export type StateProps = TStateProps<AddEntityMenuProps>;

export type DispatchProps = TDispatchProps<AddEntityMenuProps>;

const mapStateToProps = (state: State): StateProps => {
    const items = selectAddEntityItems(state);
    const limit = state.commonData.accessRights.canViewInternalAds
        ? INTERNAL_BANNERS_IN_GROUP_LIMIT
        : BANNERS_IN_GROUP_LIMIT;

    return {
        items,
        limit
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        startAddEntity: (item: AddEntityItem) => {
            dispatch(startAddEntityFromMenu(item));
        }
    };
};

export const AddEntityMenuContainer = connect<StateProps, DispatchProps, {}>(
    mapStateToProps,
    mapDispatchToProps
)(AddEntityMenu);
